import Vector from "../model/math/Vector";
import SkillTreeGraph from "../model/skillTree/SkillTreeGraph";
import { Settings } from "../Settings";
import UserInput from "./UserInput";

export default class SkillTreeInputHandler {
    /**
     * 
     * @param {UserInput} userInput 
     * @param {SkillTreeGraph} skillTreeGraph 
     */
    constructor(userInput, skillTreeGraph) {
        /**
         * @constant
         * @type {UserInput}
         */
        this.userInput = userInput;
        /**
         * @constant
         * @type {SkillTreeGraph}
         */
        this.skillTreeGraph = skillTreeGraph;

        /**
         * @type {boolean}
         */
        this.mapPanned = false;

        /**
         * @type {number}
         */
        this.mapPannedTime = 0;

        /**
         * @constant
         * @private
         * @type {Vector}
         */
        this.delta = new Vector(0, 0);

        // /**
        //  * @constant
        //  * @private
        //  * @type {Vector}
        //  */
        // this.screenCoordinate = new Vector(0, 0);
        // /**
        //  * @constant
        //  * @private
        //  * @type {Vector}
        //  */
        // this.clickWorldCoordinate = new Vector(0, 0);

    }

    /**
     */
    handleInput() {
        // Ignore mouse clicks
        if (this.userInput.leftMouseClick) {
            ////this.handleMouseClick();
            return;
        }

        ////////////////////////////////////////////
        // Panning
        ////////////////////////////////////////////

        this.handlePanning();

        ////////////////////////////////////////////
        // Zoom
        ////////////////////////////////////////////

        this.handleZoomInput();
    
    }

    resetInputHandler() {
        this.userInput.resetInputState();
    }

    // /**
    //  * @private
    //  */
    // handleMouseClick() {
    //     this.screenCoordinate.set(this.userInput.clickX, this.userInput.clickY);

    //     this.projection.screenToWorld(this.screenCoordinate, this.clickWorldCoordinate);   
    // }

    /**
     * @private
     */
    handlePanning() {

        if (this.userInput.leftMouseDown) {
            this.delta.x = this.userInput.mouseDeltaX;
            this.delta.y = this.userInput.mouseDeltaY;
        }
        else {
            // Decay
            this.delta.x *= Settings.input.panning.decayFactor;
            this.delta.y *= Settings.input.panning.decayFactor;

            // set delta xy to 0 if small enough
            if (Math.abs(this.delta.x) < 1) {
                this.delta.x = 0;
            }
            if (Math.abs(this.delta.y) < 1) {
                this.delta.y = 0;
            }
        }

        // deltaX/deltaY values are in screen coordinates. we need to convert them into world coords.
        if (this.delta.x !== 0 || this.delta.y !== 0) {

            //console.log('InputHandler.handlePanning() dx=' + this.delta.x + ' dy=' + this.delta.y);

            this.mapPanned = true;
            this.mapPannedTime = Date.now();

            this.skillTreeGraph.updateCenter(this.delta.x, this.delta.y);
        }
        else {
            this.mapPanned = false;
        }
    }

    /**
     * @private
     */
    handleZoomInput() {
        // Handle mouse wheel input here since it is the same for piloting or panning.
        var mouseWheelMotion = this.userInput.mouseWheelMotion;
        if (mouseWheelMotion < 0) {
            this.skillTreeGraph.zoomIn();
        }
        else if (mouseWheelMotion > 0) {
            this.skillTreeGraph.zoomOut();
        }
    }
}